export default __webpack_public_path__ + "static/media/breakfastFasting.5387e3a4.svg";